import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api";

/**
 * Get all questions
 * @returns Promise with all questions
 */
export const getAllQuestions = async () => {
  try {
    const response = await axios.get(`${API_URL}/questions`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all questions:", error);
    throw error;
  }
};

/**
 * Get a question by ID
 * @param id - The ID of the question
 * @returns Promise with the question data
 */
export const getQuestionById = async (id: string) => {
  try {
    const response = await axios.get(`${API_URL}/questions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching question with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Get one question by category
 * @param category - The category to filter by
 * @returns Promise with a question from the specified category
 */
export const getOneQuestionByCategory = async (category: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/questions/category/${category}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching question for category ${category}:`, error);
    throw error;
  }
};

/**
 * Create a new question
 * @param questionData - The question data
 * @returns Promise with the created question
 */
export const createQuestion = async (questionData: any) => {
  try {
    const response = await axios.post(`${API_URL}/questions`, questionData);
    return response.data;
  } catch (error) {
    console.error("Error creating question:", error);
    throw error;
  }
};

/**
 * Update a question
 * @param id - The ID of the question to update
 * @param questionData - The updated question data
 * @returns Promise with the updated question
 */
export const updateQuestion = async (id: string, questionData: any) => {
  try {
    const response = await axios.put(
      `${API_URL}/questions/${id}`,
      questionData
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating question with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Delete a question
 * @param id - The ID of the question to delete
 * @returns Promise with the deletion result
 */
export const deleteQuestion = async (id: string) => {
  try {
    const response = await axios.delete(`${API_URL}/questions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting question with ID ${id}:`, error);
    throw error;
  }
};
